export default "__VITE_ASSET__C1p1p5sv__"